// 订单与合同统一入口：语言字段在同目录维护，逻辑与显示映射在此集中管理。
import * as simplified from "./zh-CN.js";
import * as traditional from "./zh-HK.js";
import * as english from "./en-US.js";
export const zhCN = simplified.messages;
export const zhHK = traditional.messages;
export const enUS = english.messages;

// 分区导出保留原有接口，词条只在语言文件中保存一份。
export const buyOrdersZhCN = simplified.buy;
export const buyOrdersZhHK = traditional.buy;
export const buyOrdersEnUS = english.buy;
export const mobileOrdersZhCN = simplified.mobile;
export const mobileOrdersZhHK = traditional.mobile;
export const mobileOrdersEnUS = english.mobile;
export const orderDetailsZhCN = simplified.details;
export const orderDetailsZhHK = traditional.details;
export const orderDetailsEnUS = english.details;
export const mobileOrderComponentsZhCN = simplified.mobileComponents;
export const mobileOrderComponentsZhHK = traditional.mobileComponents;
export const mobileOrderComponentsEnUS = english.mobileComponents;
export const pcOrderComponentsZhCN = simplified.desktopComponents;
export const pcOrderComponentsZhHK = traditional.desktopComponents;
export const pcOrderComponentsEnUS = english.desktopComponents;
export const mobileTransactionOrdersZhCN = simplified.mobileTransactions;
export const mobileTransactionOrdersZhHK = traditional.mobileTransactions;
export const mobileTransactionOrdersEnUS = english.mobileTransactions;
export const pcTransactionOrdersZhCN = simplified.desktopTransactions;
export const pcTransactionOrdersZhHK = traditional.desktopTransactions;
export const pcTransactionOrdersEnUS = english.desktopTransactions;
export const remainingPersonalOrdersZhCN = simplified.personal;
export const remainingPersonalOrdersZhHK = traditional.personal;
export const remainingPersonalOrdersEnUS = english.personal;
export const mobileCartBrokerZhCN = simplified.broker;
export const mobileCartBrokerZhHK = traditional.broker;
export const mobileCartBrokerEnUS = english.broker;
export const mobileCheckoutZhCN = simplified.checkout;
export const mobileCheckoutZhHK = traditional.checkout;
export const mobileCheckoutEnUS = english.checkout;
export const mobileShopCartZhCN = simplified.mobileCart;
export const mobileShopCartZhHK = traditional.mobileCart;
export const mobileShopCartEnUS = english.mobileCart;
export const pcCartZhCN = simplified.desktopCart;
export const pcCartZhHK = traditional.desktopCart;
export const pcCartEnUS = english.desktopCart;
export const pcFollowZhCN = simplified.follow;
export const pcFollowZhHK = traditional.follow;
export const pcFollowEnUS = english.follow;
export const contactDialogZhCN = simplified.contact;
export const contactDialogZhHK = traditional.contact;
export const contactDialogEnUS = english.contact;
export const splitOrderDialogZhCN = simplified.split;
export const splitOrderDialogZhHK = traditional.split;
export const splitOrderDialogEnUS = english.split;
export const pcContractReviewZhCN = simplified.contractReview;
export const pcContractReviewZhHK = traditional.contractReview;
export const pcContractReviewEnUS = english.contractReview;

export const fieldLabelKeys = Object.freeze({
  产品名称: "productName",
  产品料号: "partNumber",
  产品数量: "productQuantity",
  产品单价: "unitPrice",
  产品总价: "productTotal",
  产品品牌: "brand",
  商品编号: "productNumber",
  订单编号: "orderNumber",
  品牌: "brand",
  交货地区: "deliveryRegion",
  "批次（DC）": "dateCode",
  货物情况: "goodsCondition",
  交货日期: "deliveryDate",
  订单类型: "orderType",
  售后条款: "afterSalesTerms",
  订单备注: "orderRemarks",
  合同编号: "contractNumber",
  综合总价: "grandTotal",
  付款方式: "paymentMethod",
  公司名称: "companyName",
  "公司名称(中)": "companyNameZh",
  "公司名称（中）": "companyNameZh",
  "公司名称(英)": "companyNameEn",
  "公司名称（英）": "companyNameEn",
  账户名称: "accountName",
  联系人: "contact",
  主联系人: "primaryContact",
  联系电话: "contactPhone",
  电话: "phone",
  备注: "remarks",
  公司地址: "companyAddress",
  公司税号: "taxNumber",
  商业登记号: "registrationNumber",
  银行英名: "bankNameEn",
  银行中名: "bankNameZh",
  开户银行: "bank",
  银行账号: "bankAccount",
  银行中文地址: "bankAddressZh",
  银行英文地址: "bankAddressEn",
  "银行名称（中）": "bankNameZh",
  "银行名称（英）": "bankNameEn",
  "银行地址（中）": "bankAddressZh",
  "银行地址（英）": "bankAddressEn",
  开户支行: "bankBranch",
  联行号: "bankBranchCode",
  收款账号: "receivingAccount",
  收货地址: "shippingAddress",
  收货人: "recipient",
  收货电话: "recipientPhone",
  销售总价: "salesTotal",
  采购总价: "purchaseTotal",
  利润统计: "profit",
});

export const fixedTextKeys = Object.freeze({
  发起合同审批: "initiateApproval",
  审核销售合同: "reviewSalesContract",
  查看销售合同: "viewSalesContract",
  审核销售订单: "reviewSalesOrder",
  查看销售订单: "viewSalesOrder",
  确认交易合同: "confirmTradeContract",
  审核通过: "approveReview",
  确认合同模板: "confirmTemplate",
  确认销售订单: "confirmSalesOrder",
  贸易: "trade",
  供应链: "supplyChain",
  保理放账: "factoring",
  先款后货: "payBeforeDelivery",
  先货后款: "payAfterDelivery",
  待发起: "notStarted",
  审核中: "underReview",
  已通过: "approved",
  已驳回: "rejected",
  未知: "unknown",
  填写备注: "fillRemarks",
  审核备注: "reviewRemarks",
  请填写审核人备注: "fillReviewerRemarks",
  买方: "buyer",
});

// 出库列表：状态枚举保持原值；已知机器错误码在显示出口映射。
export const outboundListZhCN = simplified.outboundList;
export const outboundListZhHK = traditional.outboundList;
export const outboundListEnUS = english.outboundList;
const outboundListErrorKeys = Object.freeze({
  GOODS_OUTBOUND_QUERY_REQUIRED: "outboundList.queryRequired",
  GOODS_OUTBOUND_APPROVAL_INVALID: "outboundList.invalidStatus",
  GOODS_OUTBOUND_DATE_ORDER: "outboundList.dateOrderError",
  GOODS_OUTBOUND_PAGE_INVALID: "outboundList.invalidPage",
  GOODS_OUTBOUND_PAGE_SIZE_INVALID: "outboundList.invalidPageSize",
  GOODS_OUTBOUND_LOGIN_REQUIRED: "common.loginRequired",
  GOODS_OUTBOUND_FORBIDDEN: "outboundList.forbidden",
  GOODS_OUTBOUND_UNAVAILABLE: "outboundList.unavailable",
});
export const outboundListErrorKey = (code) =>
  typeof code === "string" && Object.hasOwn(outboundListErrorKeys, code)
    ? outboundListErrorKeys[code]
    : null;

// 合同生成页受控固定标签；未知自填原文不猜译。
export const contractFlowZhCN = simplified.contractFlow;
export const contractFlowZhHK = traditional.contractFlow;
export const contractFlowEnUS = english.contractFlow;
const contractFlowTextKeys = Object.freeze({
  采购商务生成采购订单: "contractFlow.purchaseTitle",
  销售商务生成销售订单: "contractFlow.salesTitle",
  "填写采购订单信息，确认交易主体与审核流程": "contractFlow.purchaseIntro",
  "填写销售订单信息，确认交易主体与审核流程": "contractFlow.salesIntro",
  贸易: "contractReview.trade",
  供应链: "contractReview.supplyChain",
  代采代付: "contractFlow.purchaseOnBehalf",
  代采垫付: "contractFlow.purchaseWithAdvance",
  原厂原包: "contractFlow.factoryPackaging",
  非原厂原包: "contractFlow.nonFactoryPackaging",
  自封颗粒: "contractFlow.selfPackagedChips",
  "原标（测试）": "contractFlow.testedOriginalMarking",
  非原标: "contractFlow.nonOriginalMarking",
  翻新: "contractFlow.refurbished",
  二手: "contractFlow.used",
  销售合同: "contractFlow.salesContract",
  采购合同: "contractFlow.purchaseContract",
  付款审核: "contractFlow.paymentReview",
  订单: "contractFlow.order",
  付款: "contractFlow.payment",
  "搜索关联订单的订单编号、标题、内容等":
    "contractFlow.relatedSearchPlaceholder",
  未找到关联内容: "contractFlow.relatedNotFound",
  暂无可关联内容: "contractFlow.relatedUnavailable",
  "已选 {count} 项": "contractFlow.selectedCount",
  暂无详细信息: "contractFlow.noDetails",
  "暂无{type}详情数据": "contractFlow.missingDetails",
  关联内容加载失败: "contractFlow.relatedLoadFailed",
  展开关联内容: "contractFlow.expandRelated",
  收起关联内容: "contractFlow.collapseRelated",
  删除关联内容: "contractFlow.deleteRelated",
  选择关联订单: "contractFlow.selectRelatedOrder",
  取消选择关联订单: "contractFlow.deselectRelatedOrder",
  "选择需要关联到当前采购订单的历史订单、合同或付款审核记录":
    "contractFlow.purchaseRelatedHint",
  "选择需要关联到当前销售订单的历史订单、合同或付款审核记录":
    "contractFlow.salesRelatedHint",
  "选择需要关联到当前付款审批的历史订单、合同或付款审核记录":
    "contractFlow.paymentRelatedHint",
  搜索并选择需要同步本次采购订单进度的人员: "contractFlow.purchaseCcHint",
  搜索并选择需要同步本次销售订单进度的人员: "contractFlow.salesCcHint",
  全新原装: "adminFlows.newAndOriginal",
  原装: "bidPage.conditionOriginalGoods",
  拆机: "adminFlows.salvaged",
  散新: "adminFlows.newLoosePackaging",
  全新: "pcClue.brandNew",
  保理放账: "transactionDetail.factoring",
  先款后货: "contractReview.payBeforeDelivery",
  先货后款: "contractReview.payAfterDelivery",
  关联内容: "devUpdates.relatedContent",
  添加关联内容: "devUpdates.addRelatedContent",
  暂无关联内容: "devUpdates.noRelatedContent",
  "订单编号：": "pcOrder.orderNumber",
  收起: "mobile.home.collapse",
  展开: "mobile.home.expand",
  查看详情: "business.viewDetails",
  待发起: "contractReview.notStarted",
  审核中: "mobileBroker.underReview",
  待审核: "business.pendingReview",
  已通过: "contractReview.approved",
  审核通过: "bidPage.approve",
  已驳回: "transactionDetail.rejected",
  未知: "bidPage.unknown",
  销售: "mobileOrder.sell",
  采购: "mobileOrder.buy",
  销售订单: "pcTransaction.salesOrders",
  采购订单: "pcTransaction.purchaseOrders",
  合同: "transactionDetail.contract",
  "加载中...": "common.loading",
  没有更多数据了: "bidPage.noMore",
  取消: "business.cancel",
  确认添加: "business.confirmAdd",
  关闭: "auth.close",
});
export const contractFlowTextKey = (value) =>
  typeof value === "string" && Object.hasOwn(contractFlowTextKeys, value)
    ? contractFlowTextKeys[value]
    : null;

// 只翻译已登记的发货受控显示值；状态判断、数量、名称及未知服务端原文不变。
const mergedOrderDisplayKeys = Object.freeze({
  保理放账: "transactionDetail.factoring",
  贸易: "contractReview.trade",
  供应链: "contractReview.supplyChain",
  "银行已创建，但未能识别新银行，请点击切换重新选择":
    "devUpdates.createdBankSelectionRequired",
  订单发货: "shipping.title",
  "选择入仓号和出库单，填写本批数量和物流信息": "shipping.intro",
  订单数量: "shipping.orderQuantity",
  已发数量: "shipping.sentQuantity",
  待发数量: "shipping.remainingQuantity",
  "该订单已有历史物流，请核对原已发数量。": "shipping.historicalWarning",
  "第{sequence}批发货": "shipping.batchTitle",
  待发货: "shipping.pending",
  部分发货: "shipping.partial",
  全部发货: "shipping.complete",
  已发货: "shipping.shipped",
  删除草稿: "shipping.deleteDraft",
  添加入仓号: "shipping.addWarehouse",
  删除此行: "shipping.deleteRow",
  入仓号: "shipping.warehouseNumber",
  出库单: "shipping.outboundOrder",
  无匹配数据: "shipping.noMatches",
  请输入入仓号搜索: "shipping.warehouseSearch",
  请输入出库单搜索: "shipping.outboundSearch",
  "选择入仓号或出库单后自动关联另一栏；本次发货默认填入可发数量，可修改，不发的商品留空。":
    "shipping.sourceHint",
  "该入仓号与出库单暂无商品明细。": "shipping.sourceEmpty",
  申请出库数量: "shipping.requestedQuantity",
  剩余可发货数量: "shipping.availableQuantity",
  本次发货: "shipping.thisShipment",
  填写数量: "shipping.enterQuantity",
  "请为原草稿重新选择一组入仓号与出库单后保存。": "shipping.reselectDraft",
  请输入收货人: "shipping.enterRecipient",
  请输入联系电话: "shipping.enterPhone",
  请输入详细收货地址: "shipping.enterAddress",
  请输入物流公司: "shipping.enterCompany",
  请输入物流单号: "shipping.enterTracking",
  "发货凭证 / 备注": "shipping.proofOrRemark",
  至少填写一项: "shipping.oneRequired",
  "填写发货说明，或在下方上传凭证": "shipping.remarkPlaceholder",
  上传凭证: "shipping.uploadProof",
  "JPG、PNG、PDF，最多10个": "shipping.proofFormats",
  "添加发货（下一批）": "shipping.addBatch",
  订单商品已全部发货: "shipping.allShipped",
  "提交后，本批信息不可修改": "shipping.submitLocks",
  已发批次仅支持查看: "shipping.readOnly",
  提交本批发货: "shipping.submitBatch",
  "查询服务不可用，请核对接口地址或部署状态": "shipping.queryUnavailable",
  "查询失败，请重新搜索": "shipping.queryFailed",
  "缺少订单编号，无法建立发货记录": "shipping.orderMissing",
  加载发货信息失败: "shipping.loadFailed",
  "请先提交当前批次，再添加下一批发货": "shipping.submitCurrent",
  "该入仓号与出库单已添加，请选择其他组合": "shipping.sourceDuplicate",
  请重新选择一组入仓号与出库单后保存: "shipping.sourceRequired",
  "发货保存失败，请重试": "shipping.saveFailed",
  "发货已保存，但本地草稿清理失败，请刷新页面": "shipping.cleanupFailed",
  "本批发货已保存到服务器，信息已锁定": "shipping.saved",
  本地草稿已保存: "shipping.draftSaved",
  "确定删除当前草稿？已发货记录不受影响。": "shipping.deleteConfirmation",
  "当前批次有未保存修改，是否保存草稿后关闭？": "shipping.unsavedConfirmation",
  未保存的修改: "shipping.unsavedChanges",
  保存并关闭: "shipping.saveAndClose",
  放弃修改: "shipping.discard",
  分批发货记录: "shipping.records",
  "发货记录加载中...": "shipping.loading",
  发货记录加载失败: "shipping.historyFailed",
  商品入仓号: "shipping.goodsWarehouse",
  来源出库单: "shipping.sourceOutbound",
  发货数量: "shipping.quantity",
  "收货信息：": "shipping.receiverInfo",
  "物流信息：": "shipping.logisticsInfo",
  "买方公司：": "shipping.buyerCompany",
  "入仓号：": "shipping.warehousePrefix",
  "订单号：": "shipping.orderPrefix",
  "备注：": "shipping.remarkPrefix",
  "{name}本批合计 {quantity} {unit}，超过待发数量 {remaining}":
    "shipping.allocatedExceeded",
  已售: "shipping.sold",
  添加业务审批: "shipping.businessReview",
  出库单审核人: "shipping.outboundReviewers",
});
export function orderDisplayText(value) {
  const key =
    typeof value === "string" && Object.hasOwn(mergedOrderDisplayKeys, value)
      ? mergedOrderDisplayKeys[value]
      : null;
  return key ? this.$t(key) : value;
}

// 审核组件只转换已登记的固定标签，姓名、审核备注和自定义文案原样保留。
const workflowDisplayKeys = Object.freeze({
  审核与抄送: "contractReview.reviewAndCc",
  审批备注: "devUpdates.approvalNotes",
  审核备注: "contractReview.reviewRemarks",
  填写备注: "mobileOrderWorkflow.fillRemarks",
  请填写备注: "contractReview.fillRemarks",
  请填写审核人备注: "contractReview.fillReviewerRemarks",
  暂未获取到固定审核流程: "contractReview.noFixedFlow",
  暂无抄送人: "outboundAudit.noCc",
  正在加载默认抄送人: "contractReview.loadingCc",
  添加抄送人: "contractReview.addCc",
  填写驳回理由: "transactionDetail.rejectReason",
  请填写驳回理由: "devUpdates.enterTheRejectionReason",
  确认提交: "transactionDetail.confirmSubmit",
  发起人: "contractRoles.initiator",
  自审: "contractRoles.selfReview",
  商务经理: "contractRoles.businessManager",
  业务总监: "contractRoles.businessDirector",
  总经理: "contractRoles.generalManager",
  谈判人领导: "contractRoles.negotiatorManager",
  采购商务: "business.purchaseBusiness",
  销售商务: "transactionDetail.salesBusiness",
  采购谈判人: "business.purchaseNegotiator",
  销售谈判人: "pcOrder.salesNegotiatorRole",
});

export const workflowDisplayKey = (value) =>
  typeof value === "string"
    ? (Object.hasOwn(workflowDisplayKeys, value) ? workflowDisplayKeys[value] : null) ||
      (Object.hasOwn(mobileWorkflowDisplayKeys, value) ? mobileWorkflowDisplayKeys[value] : null)
    : null;

// 仅登记流程固定显示文字；状态判断、提交值、姓名、商品名称及用户输入保持原值。
export const mobileWorkflowDisplayKeys = Object.freeze({
  "买家": "pcOrder.buyerRole",
  "货主": "pcOrder.sellerRole",
  "买方": "contractReview.buyer",
  "卖方": "contractReview.seller",
  "INV审核中": "mobileOrderWorkflow.invoiceUnderReview",
  "INV审核已驳回": "mobileOrderWorkflow.invoiceRejected",
  "确认INV审批": "mobileOrderWorkflow.confirmInvoiceApproval",
  "查看INV审批": "mobileOrderWorkflow.viewInvoiceApproval",
  "支持上传多种类型文件": "mobileOrderWorkflow.supportedFileTypes",
  "INV（正式发票）": "mobileOrderWorkflow.invoiceFile",
  "填写本次付款审核处理意见": "mobileOrderWorkflow.paymentReviewOpinion",
  "暂无可合并订单": "mobileOrderWorkflow.noMergeableOrders",
  "当前没有其他可合并订单": "mobileOrderWorkflow.noOtherMergeableOrders",
  "包装图片": "mobileOrderWorkflow.packagingImages",
  "包装视频": "mobileOrderWorkflow.packagingVideos",
  "细节图片": "mobileOrderWorkflow.detailImages",
  "细节视频": "mobileOrderWorkflow.detailVideos",
  "添加短视频": "mobileOrderWorkflow.addShortVideo",
  "财务": "mobileOrderWorkflow.financeRole",
  "销售合同未提交": "mobileOrderWorkflow.salesContractNotSubmitted",
  "买家合同未提交": "mobileOrderWorkflow.buyerContractNotSubmitted",
  "货主未提交合同": "mobileOrderWorkflow.sellerContractNotSubmitted",
  "待发起INV审核【未复核合同】": "mobileOrderWorkflow.invoiceContractNotReviewed",
  "产品发布": "pcOrder.productPublished",
  "平台展示": "pcOrder.platformListed",
  "审核中": "contractReview.underReview",
  "待发起": "contractReview.notStarted",
  "已驳回": "transactionDetail.rejected",
  "已发货": "shipping.shipped",
  "待发货": "shipping.pending",
  "发起人": "contractRoles.initiator",
  "自审": "contractRoles.selfReview",
  "商务经理": "contractRoles.businessManager",
  "业务总监": "contractRoles.businessDirector",
  "总经理": "contractRoles.generalManager",
  "谈判人领导": "contractRoles.negotiatorManager",
  "采购订单已生成": "mobileOrderWorkflow.purchaseOrderCreated",
  "采购订单未生成": "mobileOrderWorkflow.purchaseOrderNotCreated",
  "销售订单已生成": "mobileOrderWorkflow.salesOrderCreated",
  "销售订单未生成": "mobileOrderWorkflow.salesOrderNotCreated",
  "采购合同已提交": "mobileOrderWorkflow.purchaseContractSubmitted",
  "采购合同未提交": "mobileOrderWorkflow.purchaseContractNotSubmitted",
  "采购合同模板已提交": "mobileOrderWorkflow.purchaseTemplateSubmitted",
  "销售合同已提交": "mobileOrderWorkflow.salesContractSubmitted",
  "销售合同未生成": "mobileOrderWorkflow.salesContractNotCreated",
  "待货主审核": "mobileOrderWorkflow.awaitSellerReview",
  "待买家审核": "mobileOrderWorkflow.awaitBuyerReview",
  "买家已审核": "mobileOrderWorkflow.buyerReviewed",
  "待商务上传盖章合同": "mobileOrderWorkflow.awaitBusinessStamp",
  "待货主绑定商品": "mobileOrderWorkflow.awaitSellerProductLink",
  "货主已绑定商品": "mobileOrderWorkflow.sellerProductLinked",
  "已采购报价": "mobileOrderWorkflow.purchaseQuoted",
  "待商务验货": "mobileOrderWorkflow.awaitBusinessInspection",
  "待商务经理验货": "mobileOrderWorkflow.awaitManagerInspection",
  "验货完成": "mobileOrderWorkflow.inspectionCompleted",
  "待上传双章合同": "mobileOrderWorkflow.awaitDualStamp",
  // 采购与销售的上传责任方及付款审核阶段均来自后端固定节点，只转换展示。
  "待货主上传双章合同": "mobileOrderWorkflow.awaitSellerDualStamp",
  "待买家上传双章合同": "mobileOrderWorkflow.awaitBuyerDualStamp",
  "待商务上传双章合同": "mobileOrderWorkflow.awaitBusinessDualStamp",
  "待货主上传盖章合同": "mobileOrderWorkflow.awaitSellerStamp",
  "待买家上传盖章合同": "mobileOrderWorkflow.awaitBuyerStamp",
  "付款流程审核中": "mobileOrderWorkflow.paymentReviewUnderReview",
  "付款流程已驳回": "mobileOrderWorkflow.paymentReviewRejected",
  "付款方式审核中": "mobileOrderWorkflow.paymentMethodUnderReview",
  "付款方式已驳回": "mobileOrderWorkflow.paymentMethodRejected",
  "已上传双章合同": "mobileOrderWorkflow.dualStampUploaded",
  "待上传付款凭证": "mobileOrderWorkflow.awaitPaymentProof",
  "待确认付款凭证": "mobileOrderWorkflow.awaitPaymentProofConfirmation",
  "已确认付款凭证": "mobileOrderWorkflow.paymentProofConfirmed",
  "卖家已确认收款": "mobileOrderWorkflow.sellerReceiptConfirmed",
  "待买家付款": "mobileOrderWorkflow.awaitBuyerPayment",
  "买家已付款": "mobileOrderWorkflow.buyerPaid",
  "财务确认收款": "mobileOrderWorkflow.financeReceiptConfirmed",
  "客户已收货": "mobileOrderWorkflow.customerReceived",
  "卖家已发货": "mobileOrderWorkflow.sellerShipped",
  "卖家未发货": "mobileOrderWorkflow.sellerNotShipped",
  "未发货": "mobileOrderWorkflow.notShipped",
  "审核完成": "mobileOrderWorkflow.reviewCompleted",
  "审核记录未生成": "mobileOrderWorkflow.reviewRecordMissing",
  "付款流程审核完成": "mobileOrderWorkflow.paymentReviewCompleted",
  "付款流程审核记录未生成": "mobileOrderWorkflow.paymentReviewRecordMissing",
  "付款流程待发起": "mobileOrderWorkflow.paymentReviewNotStarted",
  "付款方式审核完成": "mobileOrderWorkflow.paymentMethodReviewed",
  "付款方式待发起": "mobileOrderWorkflow.paymentMethodNotStarted",
  "待发起INV审核": "mobileOrderWorkflow.invoiceReviewNotStarted",
  "待发起INV": "mobileOrderWorkflow.invoiceNotStarted",
  "INV审核完成": "mobileOrderWorkflow.invoiceReviewed",
  "会计": "mobileOrderWorkflow.accountant",
  "出纳": "mobileOrderWorkflow.cashier",
  "确认交易订单": "workflowFeedback.confirmTradeOrder",
  "上传交易合同": "contractReview.uploadTradeContract",
  "确认付款凭证": "devUpdates.confirmPaymentReceipt",
  "贸易": "contractReview.trade",
  "供应链": "contractReview.supplyChain",
  "保理放账": "transactionDetail.factoring",
  "暂无文件": "transactionDetail.noFiles",
  "填写驳回理由": "contractReview.rejectReason",
  "确认提交": "contractReview.confirmSubmit",
  "添加采购商品": "devUpdates.addPurchaseProduct",
  "暂无可选择的采购商品": "workflowFeedback.noPurchases",
  "确认选择": "uploadLibrary.confirmSelection",
  "该商品不能取消选择": "workflowFeedback.lockedPurchase",
  "添加抄送人": "contractReview.addCc",
  "搜索抄送人姓名": "workflowFeedback.ccSearchPlaceholder",
  "抄送人": "contractReview.cc",
  "暂无可选抄送人": "workflowFeedback.noSelectableCc",
  "审核与抄送": "contractReview.reviewAndCc",
  "审批备注": "devUpdates.approvalNotes",
  "请填写审核人备注": "contractReview.fillReviewerRemarks",
  "暂未获取到固定审核流程": "contractReview.noFixedFlow",
  "暂无抄送人": "outboundAudit.noCc",
  "正在加载默认抄送人": "contractReview.loadingCc",
  "暂无关联内容": "devUpdates.noRelatedContent",
  "销售": "mobileOrder.sell",
  "采购": "mobileOrder.buy",
  "采购订单": "pcTransaction.purchaseOrders",
  "销售合同": "contractFlow.salesContract",
  "采购合同": "contractFlow.purchaseContract",
  "付款审核": "contractFlow.paymentReview",
  "已通过": "contractReview.approved",
  "未知": "contractReview.unknown",
  "待审核": "business.pendingReview",
  "选择需要关联到当前采购订单的历史订单、合同或付款审核记录": "contractFlow.purchaseRelatedHint",
  "付款": "contractFlow.payment",
  "合同": "transactionDetail.contract",
  "订单": "contractFlow.order",
  "审核采购合同": "contractReview.purchaseReviewTitle",
  "合同信息": "contractReview.contractInfo",
  "审批信息": "contractReview.approvalInformation",
  "谈判人": "transactionDetail.negotiatorRole",
  "审核备注": "contractReview.reviewRemarks",
  "请填写备注": "contractReview.fillRemarks",
  "添加审核人": "devUpdates.addReviewer",
  "公司名称(中)": "contractReview.companyNameZh",
  "公司名称(英)": "contractReview.companyNameEn",
  "商业登记号": "contractReview.registrationNumber",
  "公司税号": "contractReview.taxNumber",
  "银行英名": "contractReview.bankNameEn",
  "开户银行": "contractReview.bank",
  "银行中名": "contractReview.bankNameZh",
  "银行账号": "contractReview.bankAccount",
  "开户支行": "contractReview.bankBranch",
  "联行号": "contractReview.bankBranchCode",
  "收货地址": "contractReview.shippingAddress",
  "商品编号": "contractReview.productNumber",
  "产品名称": "contractReview.productName",
  "产品品牌": "transactionDetail.productBrand",
  "产品料号": "contractReview.partNumber",
  "产品数量": "contractReview.productQuantity",
  "产品单价": "contractReview.unitPrice",
  "产品总价": "contractReview.productTotal",
  "交货地区": "contractReview.deliveryRegion",
  "预估佣金": "devUpdates.estimatedCommission",
  "综合总价": "contractReview.grandTotal",
  "合同编号": "contractReview.contractNumber",
  "交货日期": "contractReview.deliveryDate",
  "买方类型": "devUpdates.buyerType",
  "销售谈判人": "pcOrder.salesNegotiatorRole",
  "售后条款": "contractReview.afterSalesTerms",
  "主联系人": "contractReview.primaryContact",
  "收货人电话": "devUpdates.recipientPhoneNumber",
  "发起合同审批": "contractReview.initiateApproval",
  "合同文件": "devUpdates.contractFiles",
  "关联内容": "devUpdates.relatedContent",
  "审核": "mobile.home.review",
  "采购谈判人": "business.purchaseNegotiator",
  "未命名人员": "contactDialog.unnamedPerson",
  "搜索抄送人失败": "workflowFeedback.ccSearchFailed",
  "审批中": "outboundList.inReview",
  "审核销售合同": "contractReview.reviewSalesContract",
  "采购卖方信息": "contractReview.purchaseSellerInfo",
  "采购买方信息": "contractReview.purchaseBuyerInfo",
  "订单审核人": "devUpdates.orderReviewer",
  "合同审核人": "devUpdates.contractReviewer",
  "INV审核人": "devUpdates.invReviewer",
  "付款审批流程": "devUpdates.paymentApprovalWorkflow",
  "付款审核流程": "mobileOrderWorkflow.paymentReviewFlow",
  "付款流程审核": "mobileOrderWorkflow.reviewPaymentWorkflow",
  "确认合同模板": "contractReview.confirmTemplate",
  "确认双章合同审核通过？对方复核通过后流程结束，不能再修改双章合同。": "devUpdates.approveDualStampedContractConfirmation",
  "确认销售订单": "contractReview.confirmSalesOrder",
  "发起INV审批": "invoiceApproval.initiate",
  "审核INV": "invoiceApproval.review",
  "订单编号": "contractReview.orderNumber",
  "批次（DC）": "contractReview.dateCode",
  "订单类型": "contractReview.orderType",
  "付款方式": "contractReview.paymentMethod",
  "订单备注": "contractReview.orderRemarks",
  "产品信息": "business.productInfo",
  "交易双方": "devUpdates.tradingParties",
  "商品提供人": "contractReview.productProvider",
  "采购商品": "pcOrder.purchaseProduct",
  "卖方公司": "workflowFeedback.sellerCompany",
  "买方公司": "workflowFeedback.buyerCompany",
  "买方联系人": "preOrderDetail.buyerContacts",
  "产品单位": "devUpdates.productUnit",
  "未知文件": "transactionDetail.unknownFile",
  "新建公司失败": "companyDialogs.companyCreateFailed",
  "生成订单失败": "workflowFeedback.createOrderFailed",
  "采购报价提交失败": "workflowFeedback.purchaseQuoteFailed",
  "账户名称": "contractReview.accountName",
  "公司名称（中）": "companyDialogs.companyNameZh",
  "银行名称（英）": "companyDialogs.bankNameEn",
  "收款账号": "contractReview.receivingAccount",
  "公司名称（英）": "companyDialogs.companyNameEn",
  "销售商务生成销售订单": "contractFlow.salesTitle",
  "销售商品": "pcOrder.salesProduct",
  "按商定": "devUpdates.asAgreed",
  "采购商务": "transactionDetail.purchaseBusiness",
  "销售商务": "transactionDetail.salesBusiness",
  "验货人": "pcOrder.inspectorRole",
  "全额支付": "devUpdates.payInFull",
  "分批支付": "devUpdates.payInInstallments",
  "付款凭证审核人": "devUpdates.paymentReceiptReviewer",
  "付款方式审核人": "devUpdates.paymentMethodReviewer",
  "银行简称": "companyInfo.bankShortName",
  "银中地址": "devUpdates.bankAddressChinese",
  "银英地址": "devUpdates.bankAddressEnglish",
  "尾款": "workflowFeedback.finalPayment",
  "商务跟单详情": "orderFollow.businessDetail",
  "采购商务-跟单详情": "orderFollow.purchaseBusinessDetail",
  "销售商务-跟单详情": "orderFollow.salesBusinessDetail",
  "采购谈判人-跟单详情": "preOrder.purchaseTracking",
  "销售谈判人-跟单详情": "preOrder.salesTracking",
  "请输入或上传文件地址": "goodsLibrary.enterFileUrl",
  "查看评价": "mobileOrder.viewRating",
  "待接待": "supplyForm.awaitingContact",
  "谈判人已接单": "supplyForm.negotiatorAccepted",
  "商务已接单": "supplyForm.businessAccepted",
  "已生成合同": "supplyForm.contractCreated",
  "确认金额": "supplyForm.confirmAmount",
  "买家已支付": "supplyForm.buyerPaid",
  "货主已支付": "supplyForm.sellerPaid",
  "交易完成": "personalOrderList.transactionComplete",
  "外包装": "inspection.outerPackaging",
  "中包装": "inspection.middlePackaging",
  "最小包装": "inspection.minimumPackaging",
  "产品细节": "inspection.productDetails",
  "已完成": "orderFollow.completed",
  "企业微信登录失败": "messageCenter.wecomLoginFailed",
  "企业微信登录异常": "messageCenter.wecomLoginError",
  "待验货": "inspection.pending",
  "删除入仓明细失败": "workflowFeedback.warehouseDeleteFailed",
  "驳回失败，请刷新后重试": "workflowFeedback.rejectRefresh",
  "新增供应商": "devUpdates.addSupplier",
  "主公司名称": "devUpdates.parentCompanyName",
  "公司简称": "companyInfo.shortName",
  "公司编码": "devUpdates.companyCode",
  "供应商税号": "supplier.taxNumber",
  "公司法人": "devUpdates.legalRepresentative",
  "公司电话": "companyInfo.companyPhone",
  "到期日期": "devUpdates.expiryDate",
  "建档日期": "devUpdates.profileCreated",
  "营业执照": "companyInfo.businessLicense",
  "开票资料": "companyInfo.invoiceDetails",
  "采购框架协议": "devUpdates.purchaseFrameworkAgreement",
  "供应商调查表": "devUpdates.supplierQuestionnaire",
  "未命名银行": "companyDialogs.unnamedBank",
  "查看采购订单": "workflowFeedback.viewPurchaseOrder",
  "查看采购合同": "workflowFeedback.viewPurchaseContract",
  "审核销售订单": "contractReview.reviewSalesOrder",
  "查看销售订单": "contractReview.viewSalesOrder",
  "查看销售合同": "contractReview.viewSalesContract",
  "银行中文地址": "contractReview.bankAddressZh",
  "银行英文地址": "contractReview.bankAddressEn",
  "审核驳回": "transactionDetail.rejected",
  "审核采购订单": "mobileOrderWorkflow.reviewPurchaseOrder",
  "确认采购订单": "mobileOrderWorkflow.confirmPurchaseOrder",
  "确认合同": "mobileOrderWorkflow.confirmContract",
  "确认INV": "mobileOrderWorkflow.confirmInvoice",
  "确定付款审批": "mobileOrderWorkflow.confirmPaymentApproval",
  "查看付款审批": "mobileOrderWorkflow.viewPaymentApproval",
  "发起付款方式审批": "mobileOrderWorkflow.startPaymentMethodApproval",
  "货主未审核": "mobileOrderWorkflow.ownerNotReviewed",
  "货主已审核": "mobileOrderWorkflow.ownerReviewed",
  "付款流程未提交": "mobileOrderWorkflow.paymentNotSubmitted",
  "付款审核中": "mobileOrderWorkflow.paymentUnderReview",
  "付款完成": "mobileOrderWorkflow.paymentComplete",
  "待付款": "mobileOrderWorkflow.pendingPayment",
  "已付款": "mobileOrderWorkflow.paid",
  "付款中": "mobileOrderWorkflow.paying",
  "付款失败": "mobileOrderWorkflow.paymentFailed",
  "采购付款合同": "mobileOrderWorkflow.purchasePaymentContract",
  "普通合同": "mobileOrderWorkflow.standardContract",
  "审批已结束": "mobileOrderWorkflow.approvalEnded",
  "订单完成": "mobileOrderWorkflow.orderCompleted",
  "填写备注": "mobileOrderWorkflow.fillRemarks",
  "暂时无法获取付款信息": "mobileOrderWorkflow.paymentUnavailable",
  "网络异常，请稍后重试": "mobileOrderWorkflow.networkRetry",
  "供应商还未上传PI，确认发起付款审批？": "mobileOrderWorkflow.initiateWithoutPi",
  "确认发起付款审核？": "mobileOrderWorkflow.initiatePaymentConfirmation",
  "确认订单审核通过？": "mobileOrderWorkflow.approveOrderConfirmation",
  "确认合同审核通过？": "mobileOrderWorkflow.approveContractConfirmation",
  "选择需要关联到当前合同审批的历史订单、合同或付款审核记录": "mobileOrderWorkflow.contractRelatedHint",
  "订单号待加载": "mobileOrderWorkflow.inspectionOrderLoading",
  "缺少商品编号，请返回订单页重新进入": "mobileOrderWorkflow.inspectionGoodsRequired",
  "加载商品失败": "mobileOrderWorkflow.inspectionLoadFailed",
  "加载验货状态失败": "mobileOrderWorkflow.inspectionStatusLoadFailed",
  "加载失败，请稍后重试": "mobileOrderWorkflow.inspectionRetry",
  "验货数据读取失败": "mobileOrderWorkflow.inspectionReadFailed",
  "未找到已选商品": "mobileOrderWorkflow.inspectionSelectionMissing",
  "验货附件": "mobileOrderWorkflow.inspectionAttachment",
  "商品必填信息": "mobileOrderWorkflow.goodsRequiredInfo",
  "产品必填信息": "mobileOrderWorkflow.productRequiredInfo",
  "交易双方必填信息": "mobileOrderWorkflow.partiesRequiredInfo",
  "审核人信息": "mobileOrderWorkflow.reviewerInfo",
  "暂无可选商品提供人": "mobileOrderWorkflow.noProductProviders",
  "买方联系电话": "mobileOrderWorkflow.buyerContactPhone",
  "订单信息加载失败": "mobileOrderWorkflow.orderLoadFailed",
  "当前账号无权限查看生成采购订单，请切换采购商务账号。": "mobileOrderWorkflow.purchaseAccessDenied",
  "订单信息加载失败，请返回首页后重试。": "mobileOrderWorkflow.orderLoadRetry",
  "获取商品信息失败": "mobileOrderWorkflow.goodsLoadFailed",
  "保存草稿成功": "mobileOrderWorkflow.draftSaved",
  "销售商务快捷合并交易合同": "mobileOrderWorkflow.salesMergedContract",
  "货主信息提供人": "mobileOrderWorkflow.sellerProvider",
  "买家信息提供人": "mobileOrderWorkflow.buyerProvider",
  "送货单": "mobileOrderWorkflow.deliveryNote",
  "获取验货商品列表失败": "mobileOrderWorkflow.inspectGoodsLoadFailed"
});

// 原表单仍保存“商品一”等标签，渲染时才按界面语言显示序号。
export function mobileWorkflowDisplay(value, locale) {
  if (typeof value !== "string") return null;
  const match = /^商品([一二三四五六七八九十]|[0-9]+)$/.exec(value);
  if (!match) return null;
  const ordinal = { 一: 1, 二: 2, 三: 3, 四: 4, 五: 5, 六: 6, 七: 7, 八: 8, 九: 9, 十: 10 };
  return { key: "mobileOrderWorkflow.inspectionProductLabel", params: { number: locale === "en-US" ? ordinal[match[1]] || match[1] : match[1] } };
}

// 后端流程节点可附带审核人姓名；只转换已登记的节点／角色，姓名原样保留。
export function orderWorkflowNodeText(value, translate) {
  if (typeof value !== "string") return value;
  const text = value.trim();
  if (Object.hasOwn(mobileWorkflowDisplayKeys, text)) return translate(mobileWorkflowDisplayKeys[text]);
  const separator = /[：:]/.exec(value);
  if (separator) {
    const head = value.slice(0, separator.index).trim();
    if (!Object.hasOwn(mobileWorkflowDisplayKeys, head)) return value;
    return translate(mobileWorkflowDisplayKeys[head]) + translate("pcOrder.personLabelSeparator") +
      orderWorkflowNodeText(value.slice(separator.index + 1), translate);
  }
  const accepted = /^(.+)接单$/.exec(text);
  if (accepted) return translate("mobileOrderWorkflow.orderAcceptedBy", { name: accepted[1] });
  const pending = /^待(.+)审核$/.exec(text);
  if (pending) {
    const roleKey = Object.hasOwn(mobileWorkflowDisplayKeys, pending[1]) ? mobileWorkflowDisplayKeys[pending[1]] : null;
    return translate("mobileOrderWorkflow.awaitRoleReview", { role: roleKey ? translate(roleKey) : pending[1] });
  }
  return value;
}
